<template>
<div class="chapter">
<div class="inner_page">
<img src="97813984877272.html.jpg" style="margin-right: 0px;"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97813984877272.vue?19641b06